(() => {
  const list = document.querySelector('.complementary-products--cards .complementary-products__list');
  const gallery = document.querySelector('media-gallery');

  if (!list || !gallery || typeof gallery.setActiveMedia !== 'function') return;

  const slides = Array.from(document.querySelectorAll('[data-combo-slide]'));
  const thumbs = Array.from(document.querySelectorAll('[data-combo-thumb]'));

  if (!slides.length) return;

  const activeRegularMedia = () => gallery.querySelector('.is-active[data-media-id]:not([data-combo-slide])');
  let returnMediaId = activeRegularMedia()?.dataset.mediaId || '';

  const featuredMediaFor = (variantId) =>
    Array.from(gallery.querySelectorAll('[data-variant-featured]')).find(
      (media) => media.dataset.variantId === variantId,
    );

  const panelVariantId = () => {
    const input = document.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
    return input ? String(input.value) : '';
  };

  const panelColour = () => {
    const picked = document.querySelector('.variant_color input[type="radio"]:checked, .variant_colour input[type="radio"]:checked');
    if (picked) return picked.value.trim().toLowerCase();

    const select = document.querySelector('[name="options[Colour]"], [name="options[Color]"]');
    return select ? select.value.trim().toLowerCase() : '';
  };

  const selectedHoldsIds = () =>
    Array.from(list.querySelectorAll('.product-add__checkbox.accessories:checked')).map((checkbox) => {
      const card = checkbox.closest('product-info');
      const select = card && card.querySelector('.product-complementary__select');
      return String((select && select.value) || checkbox.name);
    });

  const keyOf = (ids) => [...ids].sort().join(',');

  const matchFor = (key, panelId, colour) => {
    const sameConfig = slides.filter((slide) => slide.dataset.comboHolds === key);

    return (
      sameConfig.find((slide) => slide.dataset.comboPanel === panelId) ||
      (colour && sameConfig.find((slide) => slide.dataset.comboColour === colour)) ||
      sameConfig.find((slide) => !slide.dataset.comboPanel && !slide.dataset.comboColour)
    );
  };

  const thumbFor = (slide) => thumbs.find((thumb) => thumb.dataset.target === slide.dataset.mediaId);

  const mediaById = (mediaId) => (mediaId ? gallery.querySelector(`[data-media-id="${mediaId}"]`) : null);

  let shownMediaId = '';

  const showMedia = (mediaId) => {
    shownMediaId = mediaId;
    gallery.setActiveMedia(mediaId, true, true);

    const media = mediaById(mediaId);
    if (media) setTimeout(() => media.parentElement.scrollTo({ left: media.offsetLeft }));
  };

  const scrollToShownMedia = () => {
    const media = mediaById(shownMediaId);
    if (!media) return;

    const rect = media.getBoundingClientRect();
    const viewport = window.innerHeight || document.documentElement.clientHeight;
    const visible = Math.min(rect.bottom, viewport) - Math.max(rect.top, 0);

    if (visible >= Math.min(rect.height, viewport) * 0.6) return;

    const top = window.scrollY + rect.top - 16;
    window.scrollTo({ behavior: 'smooth', top: Math.max(top, 0) });
  };

  const keepAnchored = (anchor, run) => {
    if (!anchor) {
      run();
      return;
    }

    const before = anchor.getBoundingClientRect().top;
    run();
    const shift = anchor.getBoundingClientRect().top - before;

    if (Math.abs(shift) > 1) window.scrollBy({ behavior: 'instant', top: shift });
  };

  const update = (focusHoldsId) => {
    const regularMedia = activeRegularMedia();
    if (regularMedia) returnMediaId = regularMedia.dataset.mediaId;

    const panelId = panelVariantId();
    const colour = panelColour();
    const selected = selectedHoldsIds();
    const wanted = new Set();

    const exact = selected.length ? matchFor(keyOf(selected), panelId, colour) : null;

    if (exact) {
      wanted.add(exact);
    } else {
      selected.forEach((holdsId) => {
        const slide = matchFor(holdsId, panelId, colour);
        if (slide) wanted.add(slide);
      });
    }

    slides.forEach((slide) => {
      slide.classList.toggle('combo-media--hidden', !wanted.has(slide));
      const thumb = thumbFor(slide);
      if (thumb) thumb.classList.toggle('combo-media--hidden', !wanted.has(slide));
    });

    if (!wanted.size) {
      const returnMedia =
        featuredMediaFor(panelId) ||
        Array.from(gallery.querySelectorAll('[data-media-id]')).find(
          (media) => media.dataset.mediaId === returnMediaId,
        );
      if (returnMedia) showMedia(returnMedia.dataset.mediaId);
      return;
    }

    const focus = focusHoldsId && matchFor(focusHoldsId, panelId, colour);
    const target = focus && wanted.has(focus) ? focus : wanted.values().next().value;
    showMedia(target.dataset.mediaId);
  };

  list.addEventListener('change', (event) => {
    const card = event.target.closest('.complementary-products__item');

    if (event.target.classList.contains('product-add__checkbox')) {
      keepAnchored(card, () => update(String(event.target.name)));
      return;
    }

    if (event.target.classList.contains('product-complementary__select')) {
      keepAnchored(card, () => update());
    }
  });

  list.addEventListener('click', (event) => {
    if (event.target.closest('.product-add__checkbox-wrap, .product-complementary__inputs-wrap, a, select, input, label')) {
      return;
    }

    const card = event.target.closest('product-info');
    const checkbox = card && card.querySelector('.product-add__checkbox.accessories');
    if (!checkbox) return;

    const select = card.querySelector('.product-complementary__select');
    const holdsId = String((select && select.value) || checkbox.name);

    if (!matchFor(holdsId, panelVariantId(), panelColour())) return;

    if (!checkbox.checked) {
      checkbox.checked = true;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      keepAnchored(card, () => update(holdsId));
    }

    scrollToShownMedia();
  });

  document.addEventListener('venue:variant:updated', () => update());
})();
